<template>
  <div id="app">
    <div>
      <div class="c-wrapper select-filter" style="margin-bottom: 20px;">
        <div class="row">
          <div class="col-md-12 mb-3 mb-lg-0 col-lg-auto">
            <div class="select-filter__item">
              <div class="select-filter__label">Укажите количество гостей в каюте:</div>
              <div class="select-filter__select">
                <div class="select-filter__select-control">
                  {{ capacity > 0 ? capacityPlaceholder : 'Количество гостей' }}
                </div>
                <div class="select-filter__select-list">
                  <div class="cabins-tariffs__list">
                    <div class="cabins-tariffs__item">
                      <div class="cabins-tariffs__name">Взрослые + дети</div>
                      <div class="product-counter cabins-tariffs__counter product-counter_red">
                                <span class="product-counter__minus" @click="capacityMinus()">
                                  <svg class="icon icon-minus">
                                    <use xlink:href="./assets/img/sprite.svg#icon-minus"></use>
                                  </svg>
                                </span>
                        <input type="text" name="productCount" maxlength="3" :value="capacity"
                               data-category="гость,гостей,гостей"
                               class="product-counter__value select-filter__counter">
                        <span class="product-counter__plus" @click="capacityPlus()">
                                  <svg class="icon icon-plus">
                                    <use xlink:href="./assets/img/sprite.svg#icon-plus"></use>
                                  </svg>
                                </span>
                      </div>
                    </div>
                  </div>
                  <div class="select-filter__select-list-controls">
                    <a href="#" class="select-filter__clear mb-2" @click.prevent="capacity = 1;setCapacity(capacity)">Очистить</a>
                    <a href="#" class="select-filter__apply mb-2">Применить</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 mb-3 mb-lg-0 col-lg-auto">
            <div class="select-filter__item">
              <div class="select-filter__label">Скидка:</div>
              <div class="select-filter__select">
                <div class="select-filter__select-control">Доступные скидки</div>
                <div class="select-filter__select-list">
                  <div class=" custom-radio mb-2" v-for="discount in listCabinDiscount">
                    <!--                    <input type="radio" :id="discount.ID" name="checkAction" value=""-->
                    <!--                           @click="setActiveDiscountId(discount.ID)"-->
                    <!--                           :data-value="`${discount.name} (${discount.discount_price}%)`"-->
                    <!--                           class="custom-control-input select-filter__radio">-->
                    <span class="custom-control-label_price">{{ discount.discount_price }}%</span> - {{ discount.name }}<br>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="quick-filter d-sm-none d-md-block">
        <a
            href="javascript:void(0)"
            class="quick-filter__control btn-control btn-control-outline-primary rounded-0 mr-3"
            :class="{'active': allLocActive}"
            @click.prevent="toggleAllLoc()"
        >Все</a>

        <a v-for="loc in listCabinLoc" :key="loc.ID"
           class="quick-filter__control btn-control btn-control-outline-primary rounded-0 mr-3"
           :class="{'active quick-filter__control--checked':  isActiveCabinLoc(loc.ID) }"
           :style="{'order': loc.sort}"
           @click="toggleActiveCabinLoc(+loc.ID)"
           href="javascript:void(0)">{{ loc.name }} ({{ listCabinCabinByLoc(+loc.ID).length }}) </a>
      </div>
      <div class="c-wrapper cabins-descriptor" style="display: none;">
        <div class="d-flex align-items-center" style="display: none;">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.34918 17.7094C1.50238 17.7094 0 19.212 0 21.0588V22.8658C0 23.2542 0.314758 23.569 0.703125 23.569H5.99524C6.38361 23.569 6.69836 23.2542 6.69836 22.8658V21.0588C6.69836 19.212 5.19598 17.7094 3.34918 17.7094Z"
                fill="#8F1416"/>
            <path
                d="M3.34875 17.2683C4.6369 17.2683 5.68481 16.2204 5.68481 14.9323C5.68481 13.6441 4.6369 12.596 3.34875 12.596C2.06061 12.596 1.0127 13.6441 1.0127 14.9323C1.0127 16.2204 2.06061 17.2683 3.34875 17.2683Z"
                fill="#8F1416"/>
            <path
                d="M11.9996 17.7094C10.1528 17.7094 8.65039 19.212 8.65039 21.0586V22.8658C8.65039 23.2542 8.96515 23.569 9.35352 23.569H14.6456C15.034 23.569 15.3488 23.2542 15.3488 22.8658V21.0588C15.3488 19.212 13.8464 17.7094 11.9996 17.7094Z"
                fill="#8F1416"/>
            <path
                d="M9.66406 14.9323C9.66406 16.2204 10.712 17.2683 12.0001 17.2683C13.2883 17.2683 14.3362 16.2204 14.3362 14.9323C14.3362 13.6441 13.2883 12.596 12.0001 12.596C10.712 12.596 9.66406 13.6441 9.66406 14.9323Z"
                fill="#8F1416"/>
            <path
                d="M20.6509 17.7094C18.8041 17.7094 17.3018 19.212 17.3018 21.0586V22.8658C17.3018 23.2542 17.6165 23.569 18.0049 23.569H23.297C23.6854 23.569 24.0001 23.2542 24.0001 22.8658V21.0588C24.0001 19.212 22.4977 17.7094 20.6509 17.7094Z"
                fill="#8F1416"/>
            <path
                d="M18.3145 14.9323C18.3145 16.2204 19.3624 17.2683 20.6505 17.2683C21.9387 17.2683 22.9866 16.2204 22.9866 14.9323C22.9866 13.6441 21.9387 12.596 20.6505 12.596C19.3624 12.596 18.3145 13.6441 18.3145 14.9323Z"
                fill="#8F1416"/>
            <path
                d="M5.02832 11.4417H10.3204C10.7088 11.4417 11.0236 11.1268 11.0236 10.7386V8.93134C11.0236 7.08453 9.52118 5.58215 7.67438 5.58215C5.82758 5.58215 4.3252 7.08453 4.3252 8.93134V10.7386C4.3252 11.1268 4.63995 11.4417 5.02832 11.4417Z"
                fill="#8F1416"/>
            <path
                d="M7.67493 5.14105C8.96326 5.14105 10.0112 4.09296 10.0112 2.80481C10.0112 1.51666 8.96326 0.46875 7.67493 0.46875C6.38678 0.46875 5.33887 1.51666 5.33887 2.80499C5.33887 4.09314 6.38678 5.14105 7.67493 5.14105Z"
                fill="#8F1416"/>
            <path
                d="M13.6797 11.4417H18.9718C19.3602 11.4417 19.6749 11.1268 19.6749 10.7386V8.93134C19.6749 7.08453 18.1725 5.58215 16.3257 5.58215C14.4789 5.58215 12.9766 7.08453 12.9766 8.93134V10.7386C12.9766 11.1268 13.2915 11.4417 13.6797 11.4417Z"
                fill="#8F1416"/>
            <path
                d="M16.3253 5.14105C17.6135 5.14105 18.6616 4.09296 18.6616 2.80481C18.6616 1.51666 17.6135 0.46875 16.3253 0.46875C15.0372 0.46875 13.9893 1.51666 13.9893 2.80499C13.9893 4.09314 15.0372 5.14105 16.3253 5.14105Z"
                fill="#8F1416"/>
          </svg>
          <div>Для любой компании подберем каюты! Оставьте заявку, или позвоните по номеру телефона указанному в
            шапке сайта.
          </div>
        </div>
      </div>
      <div class="cabins-list">
        <div class="row" v-for="loc in listCabinLoc" :key="`loc-${loc.ID}`" v-show="isActiveCabinLoc(loc.ID)"
             :style="{'order': loc.sort}" v-if="+listCabinCabinByLoc(+loc.ID).length !== 0">
          <div class="col-12" :id="`loc-${loc.ID}`"><h2>{{ loc.name }}</h2></div>
          <div class="col-12" style="display: flex; flex-direction: column;">
            <form v-for="group in listCabinGroupByLoc(+loc.ID)" :key="`group-${group.ID}`" action=""
                  class="cabins-option"
                  v-show="isActiveCabinGroup(group.ID)" :style="{'order': group.sort}">
              <div class="cabins-option__col cabins-option__col--1"
                   :class="{'d-sm-none d-md-flex': isShowGroup(group.ID)}">
                <div class="cabins-types" style="width: 100%">
                  <div class="cabins-types__name">{{ group.name }}</div>
                  <div class="cabins-types__description">Выберите категорию каюты</div>
                  <div class="cabins-types__list">
                    <div v-for="cabin of listCabinByGroup(group.ID)"
                         :key="`cabin-${group.ID}-${cabin.ID}-${loc.ID}`"
                         class="cabins-types__item"
                         :style="{'order': cabin.sort}"
                         @click="setCheckGroupCabin({groupId: group.ID, cabinId: cabin.ID})"
                    >
                      <!--                      {{ cabin }}-->
                      <input class="cabins-types__input" type="radio"
                             name="type"
                             :checked="checkGroupCabin(+group.ID, +cabin.ID)"
                             :id="`cabin-${group.ID}-${cabin.ID}`">

                      <label class="cabins-types__label" :for="`${group.ID}-${cabin.ID}`">
                            <span class="row no-gutters w-100">
                              <span class="col-xl-9 col-9">
                                <span class="cabins-types__label-name">{{ cabin.name }}</span>
                              </span>
                              <span class="col-xl-3 col-3" style="text-align: right">
                                <span class="cabins-types__label-cost" style="white-space: nowrap">
                                  <b>{{ costFormatted(getCabinCostFrom(cabin.ID), true) }} Р</b>
                                </span><br>
                                <span class="cabins-types__label-cost" v-if="getCabinCostFromCourse(cabin.ID)"
                                      style="color: rgb(143, 20, 22); position: relative; top: -5px; white-space: nowrap">
                                  {{ costFormatted(getCabinCostFromCourse(cabin.ID)) }} {{ getCurrency }}
                                </span>
                                <span class="cabins-types__label-note" v-html="cabin.info"></span>
                              </span>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cabins-option__col cabins-option__col--2">
                <div class="row no-gutters">
                  <div class="col-12">
                    <div v-if="group.image_id" class="cabins-group-image simple-slider swiper-container">
                      <div class="swiper-wrapper">
                        <div class="swiper-slide">
                          <img :src="`https://astartagroup.ru/${group.image}`" alt="">
                        </div>
                      </div>
                      <div class="simple-slider-button-next" style="display:none;">
                        <svg class="icon icon-arrow">
                          <use xlink:href="./assets/img/sprite.svg#icon-arrow"></use>
                        </svg>
                      </div>
                      <div class="simple-slider-button-prev" style="display:none;">
                        <svg class="icon icon-arrow">
                          <use xlink:href="./assets/img/sprite.svg#icon-arrow"></use>
                        </svg>
                      </div>
                      <div class="simple-slider-pagination" style="display:none;"></div>
                    </div>
                    <div v-else class="cabins-group__information">
                      <img src="./assets/img/noimage.jpg" alt="">
                    </div>
                    <div class="cabins-equipment__list" v-if="group.info">
                      <div class="cabins-equipment__list" v-html='group.info'></div>
                      <br>
                    </div>
                    <span class="cabins-types__label-cost d-md-none">От <b>
                                  {{
                        costFormatted(getCabinCostFrom(getCheckedGroupCabin(group.ID)), true)
                      }} Р</b> <span
                        style="display:none;">/
                                  {{
                        costFormatted(getCabinCostFromCourse(getCheckedGroupCabin(group.ID)))
                      }} €</span></span>
                    <div class="cabins-privilege__more" v-if="getCabinById(getCheckedGroupCabin(group.ID)).info">
                      <!--                      <a href="#" class="cabins-privilege__show">Описание</a>-->
                      <div v-html="group.info"></div>
                      <!--                      <ul class="cabins-privilege__more-list">-->
                      <!--                        <div v-html="group.info"></div>-->
                      <!--                      </ul>-->
                    </div>
                    <div class="text-center" style="margin-top: 20px">
                      <div class="btn btn-primary d-md-none" @click="showGroup(group.ID)"
                           :class="{'d-none': !isShowGroup(group.ID)}">Выбрать каюту
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cabins-option__col cabins-option__col--3 cabins-tariffs__wrapper"
                   :class="{'d-sm-none d-md-flex': isShowGroup(group.ID)}">
                <div class="cabins-tariffs__btn d-md-none col-12 text-center"
                     :class="{'d-none': !isShowGroupTariff(group.ID)}">
                  <div class="btn btn-primary" @click="showGroupTariff(group.ID)">
                    Выберите тарифы
                  </div>
                </div>
                <div class="cabins-tariffs__body d-md-block" :class="{'d-none': isShowGroupTariff(group.ID)}">
                  <div class="cabins-tariffs__title">Выберите тарифы</div>
                  <div class="cabins-tariffs__description">{{ getUserInfo }}</div>
                  <div class="cabins-tariffs__list" v-if="listCabinByGroup(group.ID).length">
                    <div v-for="tariff in listCabinTariffByCabin(getCheckedGroupCabin(group.ID))"
                         :key="tariff.ID"
                         class="cabins-tariffs__item"
                         :style="{'order': tariff.sort}"
                         v-show="!!(getPriceByCabinTariff(cruiseId, tariff.ID))"
                    >
                      <template v-if="!!(getPriceByCabinTariff(cruiseId, tariff.ID))">
                        <div class="cabins-tariffs__name">{{ tariff.name }}</div>
                        <div class="product-counter cabins-tariffs__counter">
                            <span class="product-counter__minus" @click="removeTariffCount(tariff.ID)">
                              <svg class="icon icon-minus">
                                <use xlink:href="./assets/img/sprite.svg#icon-minus"></use>
                              </svg>
                            </span>
                          <input type="text" name="productCount" maxlength="3" :value="tariff.count"
                                 class="product-counter__value">
                          <span class="product-counter__plus" @click="addTariffCount(tariff.ID)">
                              <svg class="icon icon-plus">
                                <use xlink:href="./assets/img/sprite.svg#icon-plus"></use>
                              </svg>
                            </span>
                        </div>
                        <div class="cabins-tariffs__cost">
                          <b>{{
                              costFormatted(getPriceByCabinTariff(cruiseId, tariff.ID, tariff.count), true)
                            }}
                            Р</b>
                          <div v-if="getPriceByCabinTariffCourse(cruiseId, tariff.ID, tariff.count)"
                               style="white-space: nowrap">
                            &nbsp{{ costFormatted(getPriceByCabinTariffCourse(cruiseId, tariff.ID, tariff.count)) }}
                            {{ getCurrency }}
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="cabins-tariffs__footer d-md-block" :class="{'d-none': isShowGroupTariff(group.ID)}">
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="cabins-tariffs__total" v-if="getCheckedGroupCabin(group.ID)">
                        <b>{{ costFormatted(getCabinCostBasket(getCheckedGroupCabin(group.ID)), true) }} Р</b>
                        <span style="display: none">/ {{
                            costFormatted(getCabinCostBasketCourse(getCheckedGroupCabin(group.ID)))
                          }} €</span>
                      </div>
                      <div class="cabins-tariffs__total-description">Цена за человека при двухместном размещении</div>
                    </div>
                    <div class="col-xl-6">
                      <button type="submit" class="btn-control btn-control-block btn-control-primary mb-3"
                              @click.pre.prevent="sendOrder( +getCheckedGroupCabin(group.ID))">Отправить
                        заявку
                      </button>
                    </div>
                    <div class="col-12 d-none">
                      <div class="total-details">
                        <a class="total-details__control" href="#">Узнать детали
                          <svg class="icon icon-arrow">
                            <use xlink:href="./assets/img/sprite.svg#icon-arrow"></use>
                          </svg>
                        </a>
                        <div class="total-details__list">
                          <div class="total-details__item">
                            <div class="row">
                              <div class="col-7">
                                <div class="total-details__name">Взрослый, с пакетом экскурсий, 3-х разовое питание
                                </div>
                              </div>
                              <div class="col-2">
                                <div class="total-details__count text-center">1</div>
                              </div>
                              <div class="col-3">
                                <div class="total-details__cost text-right">
                                  <b>18 749 ₽</b>
                                  <div>260 €</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="total-details__item">
                            <div class="row">
                              <div class="col-7">
                                <div class="total-details__name">Дополнительное взрослое место с пакетом экскурсий,
                                  3-х разовое питание
                                </div>
                              </div>
                              <div class="col-2">
                                <div class="total-details__count text-center">2</div>
                              </div>
                              <div class="col-3">
                                <div class="total-details__cost text-right">
                                  <b>18 749 ₽</b>
                                  <div>260 €</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="total-details__item">
                            <div class="row">
                              <div class="col-7">
                                <div class="total-details__name">Портовые сборы</div>
                              </div>
                              <div class="col-2">
                                <div class="total-details__count text-center"></div>
                              </div>
                              <div class="col-3">
                                <div class="total-details__cost text-right">
                                  <b>18 749 ₽</b>
                                  <div>260 €</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: 'App',
  components: {},
  data() {
    return {
      capacity: 1,
      listShowGroupTariff: [],
      listShowGroup: [],
      maxCapacity: 0
    }
  },
  async mounted() {
    console.log(Math.trunc(window.cruise.cost_multiplier))
    await this.setCourse(window.cruise.cost_multiplier);
    await this.setCurrency(window.cruise.currency);
    await this.setUserInfo(window.cruise.userInfo);
    this.setCruiseId(window.cruise.id);
    this.setListCabin(JSON.parse(JSON.stringify(window.cruise.listCabin)));
    this.setListCabinPrice(JSON.parse(JSON.stringify(window.cruise.listCabinPrice)));
    this.setListCabinGroup(JSON.parse(JSON.stringify(window.cruise.listCabinGroup)));
    this.setListCabinTariff(JSON.parse(JSON.stringify(window.cruise.listCabinTariff)));
    this.setListCabinLoc(JSON.parse(JSON.stringify(window.cruise.listCabinLoc)));
    this.setListCabinDiscount(JSON.parse(JSON.stringify(window.cruise.listCabinDiscount)));
    this.autoSetMaxCapacity();
    this.autoSetCheckedGroupCabin();
    this.fullActiveCabinLoc();
  },
  methods: {
    sendOrder(cabinId) {
      let costBasket = this.getCabinCostBasket(cabinId);
      let cabin = this.getCabinById(cabinId);
      if ($) {
        let comment = '';

        comment += 'Каюта: ' + cabin.name + '\n\r';
        if (costBasket > 0) {
          comment += 'Стоимость: ' + costBasket + ' ₽ \n\r';
        }


        $('#comment').val(comment);

        $([document.documentElement, document.body]).animate({
          scrollTop: $("#order-form").offset().top
        }, 2000);
      }
    },
    declOfNum(number, titles) {
      let cases = [2, 0, 1, 1, 1, 2];
      return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    },
    capacityPlus() {

      if (this.capacity < this.maxCapacity) {
        this.capacity += 1;
        this.setCapacity(this.capacity);
      }

    },
    capacityMinus() {
      if (this.capacity > 1) {
        this.capacity -= 1;
        this.setCapacity(this.capacity);
      }
    },
    checkGroupCabin(groupId, cabinId) {
      return (+this.$store.getters.listCheckedGroupCabin[+groupId] === +cabinId)
    },
    ...mapActions([
      'toggleActiveCabinLoc',
      'toggleAllLoc',
      'autoSetCheckedGroupCabin',
    ]),
    ...mapMutations([
      'setActiveDiscountId',
      'setCheckGroupCabin',
      'addTariffCount',
      'removeTariffCount',
      'setCourse',
      'setCurrency',
      'setCruiseId',
      'setListCabin',
      'setListCabinDiscount',
      'setListCabinPrice',
      'setListCabinGroup',
      'setListCabinTariff',
      'setListCabinLoc',
      'addActiveCabinLoc',
      'removeActiveCabinLoc',
      'fullActiveCabinLoc',
      'setCapacity',
      'setUserInfo'
    ]),
    autoSetMaxCapacity() {
      this.maxCapacity = this.listCabin.reduce((res, cur) => {
        if (+cur.capacity > res) {
          res = cur.capacity;
        }
        return res
      }, -Infinity)
      // this.setCapacity(this.maxCapacity)
    },
    isShowGroupTariff(groupId) {
      if (this.listShowGroupTariff.indexOf(groupId) === -1) {
        return true;
      }
      return false;
    },
    isShowGroup(groupId) {
      if (this.listShowGroup.indexOf(groupId) === -1) {
        return true;
      }
      return false;
    },
    showGroupTariff(groupId) {
      if (this.isShowGroupTariff(groupId)) {
        this.listShowGroupTariff.push(groupId);
      } else {
        this.listShowGroupTariff.splice(this.listShowGroupTariff.indexOf(groupId), 1);
      }
      // console.log(this.listShowGroupTariff);
    },
    showGroup(groupId) {
      if (this.isShowGroup(groupId)) {
        this.listShowGroup.push(groupId);
      } else {
        this.listShowGroup.splice(this.listShowGroup.indexOf(groupId), 1);
      }
    },
    costFormatted(cost, zero = false) {
      if (zero) {
        return (Math.trunc(+cost / 100) * 100).toLocaleString('en-US').replace(',', ' ')
      } else {
        return (+cost).toLocaleString('en-US').replace(',', ' ')
      }
    }
  },
  computed: {
    ...mapGetters([
      'listCabinCabinByLoc',
      'activeCabinDiscount',
      'cruiseId',
      'listCabin',
      'listCabinDiscount',
      'listCabinPrice',
      'listCabinGroup',
      'listCabinGroupByLoc',
      'listCabinTariff',
      'listCabinLoc',
      'isActiveCabinLoc',
      'isActiveCabinGroup',
      'allLocActive',
      'listCabinByGroup',
      'listCabinTariffByCabin',
      'listCheckedGroupCabin',
      'getCabinById',
      'getPriceByCabinTariff',
      'getPriceByCabinTariffCourse',
      'getCabinCostFrom',
      'getCabinCostFromCourse',
      'getCabinCostBasket',
      'getCabinCostBasketCourse',
      'getCheckedGroupCabin',
      'getCurrency',
      'getUserInfo'
    ]),
    capacityPlaceholder() {
      return `${this.capacity} ${this.declOfNum(this.capacity, ['гость', 'гостя', 'гостей'])}`
    }
  },

}
</script>

<style lang="sass" scoped>

@import "./assets/sass/app.sass"

.custom-control-label_price
  color: red
  font-weight: bold

.swiper-slide
  width: 300px

  img
    width: 300px

.cabins-group__information
  img
    width: 300px


@media only screen and (max-width: 767px)
  .swiper-slide
    min-width: 200px
    width: 100%

    img
      min-width: 200px
      width: 100%

  .cabins-group__information
    img
      width: 200px

  .d-sm-none
    display: none !important

@media only screen and (min-width: 768px)
  .d-md-flex
    display: flex !important

</style>